<div class="m-sidebar"
     ref="baseWindow">
    <slot name="trigger"></slot>
    <portal :target-el="portalTargetSelector"
            v-if="portalCreated">
        <transition name="m--is">
            <div v-show="propOpen"
                 v-if="portalMounted"
                 ref="modalWrap"
                 class="m-sidebar__wrap"
                 :class="[
                    {
                        'm--is-close-on-backdrop': closeOnBackdrop,
                        'm--is-disabled':disabled,
                        'm--is-full-height': fullHeight
                    },
                    'm--is-origin-' + origin,
                    className
                 ]"
                 @click.self="backdropClick">
                <article class="m-sidebar__article"
                         ref="article"
                         :style="{
                             width: propWidth,
                             'margin-left': marginLeft
                         }"
                         tabindex="-1">
                    <button v-if="closeButton && origin === 'bottom'"
                            class="m-sidebar__close-button"
                            type="button"
                            @click="closeModal()">
                        {{ $i18n.translate('m-sidebar:close') }}
                    </button>
                    <header v-if="$slots.header || hasHeader"
                            class="m-sidebar__header"
                            :class="{
                                'm--has-close-button-right': closeButton && closeButtonPosition === 'right' && origin !== 'bottom',
                                'm--has-close-button-left': closeButton && closeButtonPosition === 'left' && origin !== 'bottom',
                                'm--no-content': (!$slots.header || !title) && closeButton && origin !== 'bottom',
                                'm--no-padding': !padding || !paddingHeader
                            }">
                        <h2 v-if="title" class="m-sidebar__title">{{ title }}</h2>
                        <slot name="header" />
                        <m-icon-button v-if="closeButton && origin !== 'bottom'"
                                       class="m-sidebar__header__close-button"
                                       icon-name="m-svg__close-clear"
                                       @click="closeModal">
                            {{ $i18n.translate('m-sidebar:close') }}
                        </m-icon-button>
                    </header>
                    <div v-if="$slots.default"
                         class="m-sidebar__body"
                         :class="{ 'm--no-padding': !padding || !paddingBody }"
                         ref="body">
                        <slot />
                    </div>
                    <footer v-if="$slots.footer"
                            class="m-sidebar__footer"
                            :class="{ 'm--no-padding': !padding || !paddingFooter }">
                        <slot name="footer" />
                    </footer>
                </article>
            </div>
        </transition>
    </portal>
</div>
